const accordionSections = document.querySelectorAll('.ctn_accordion[section_id]');
accordionSections.forEach(section => {
    initAccordionImage(section);
});

function initAccordionImage(section) {
    const sectionId = section.getAttribute('section_id');
    if (!sectionId) return;
    
    const accordionHeaders = section.querySelectorAll('.accordion_header');
    
    // Open first accordion by default
    if (accordionHeaders.length > 0) {
        const firstHeader = accordionHeaders[0];
        const firstContent = firstHeader.nextElementSibling;
        
        if (firstContent) {
            firstContent.style.maxHeight = firstContent.scrollHeight + 'px';
            firstHeader.classList.add('active');
            firstHeader.parentNode.classList.add('active');
        }
    }
    
    // Add click event to each accordion header
    accordionHeaders.forEach(header => {
        header.addEventListener('click', () => {
            const content = header.nextElementSibling;
            if (!content) return;
            
            const isOpen = content.style.maxHeight;
            
            // Close all accordions in this section
            section.querySelectorAll('.accordion_content').forEach(item => {
                item.style.maxHeight = null;
            });
            
            section.querySelectorAll('.accordion_header').forEach(h => {
                h.classList.remove('active');
                h.parentNode.classList.remove('active');
            });
            
            if (!isOpen) {
                content.style.maxHeight = content.scrollHeight + 'px';
                header.classList.add('active');
                header.parentNode.classList.add("active");
            }
        });
    });
}
